
import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Link, withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch, useSelector } from "react-redux";
export const ActionEdit = ({parentCallback,disableFieldsRule}) => {
  const y = useSelector((state) => state.pageReducer.andState);
  const [disableFields, setDisableFields] = useState(true);

    const [hideSkeleton, setHideSkeleton] = useState();
    const [hideSkeleton1, setHideSkeleton1] = useState();
    const [hideSkeleton2, setHideSkeleton2] = useState();
    const [mapArray2, setMapArray2] = useState([
      {
        attribute: null,
        operations: null,
        values: "",
        butt: "",
        messageSource: null,
      },
    ]);
    
    const [actionData, setActionData] = useState([]);
    const [actionData1, setActionData1] = useState([]);

    const [conditionData3, setConditionData3] = useState([]);
    const [attribute3Index, setAtribute3Index] = useState(undefined);
      const [mapState2, setMapState2] = useState(false);




      let temp_arr2 = [...mapArray2];
  // console.log("temp_arr--", mapArray2);
  const addRule2 = () => {
    setAtribute3Index(undefined);
    setDisableFields(false)

    let a = {
      attribute: null,
      operations: null,
      values: "",
      butt: "",
      checkForNewVal:true

    };
    temp_arr2.push(a);
    const array21 = temp_arr2?.map((d) => d?.attribute?.attribute);
    const notPresentInArray2 = actionData.filter((value) => {
      return !array21.includes(value?.attribute);
    });
    // setMapArray(temp_arr);
    setMapArray2(temp_arr2);
    setActionData(notPresentInArray2);
  };
  // useEffect(() => {
  //   let x = [...conditionData3];
  //   // setConditionData1(map)
  //   x[attribute3Index] =
  //     mapArray2[attribute3Index]?.attribute?.actionOperations;

  //   // x.push(mapArray2[attribute3Index]?.attribute?.actionOperations);
  //   if (mapState2 == true) {
  //     // alert("hii");
  //     setConditionData3(x);
  //   }
  //   // setConditionData1(mapArray[attribute1Index]?.attribute?.rulesOperations);
  //   // setMapArray(mapArray[attribute1Index].attribute)
  // }, [mapArray2[attribute3Index]?.attribute]);



  useEffect(() => {
    // alert("hii");
    let x = [...conditionData3];
    console.log(
      "PPPPPPP",
      x,
      x[attribute3Index],
      mapArray2[attribute3Index]?.attribute,
      mapArray2[attribute3Index]?.attribute?.actionOperations,
      (x[attribute3Index] =
        mapArray2[attribute3Index]?.attribute?.actionOperations),
      attribute3Index
    );

    actionData1?.forEach((ddd, indexxx) => {
     
      if (ddd?.attribute == mapArray2?.[attribute3Index]?.attribute?.attribute) {
        
        x[attribute3Index] = ddd.actionOperations;
      }
    });

    // x.push(mapArray2[attribute1Index]?.attribute?.rulesOperations);
    // x[attribute1Index] = mapArray2[attribute1Index]?.attribute?.rulesOperations;
  
    if (mapState2 == true) {
      setConditionData3(x);
    }
  }, [mapArray2[attribute3Index]?.attribute]);




      const firstaction = (index) => {
        setAtribute3Index(index);
        setDisableFields(true)

        let temp_arraction = [...mapArray2];
        const previousSecondElementOfTheArray = temp_arraction.filter(
          (val, indexx) => index != indexx
        );
    
        console.log(
          "IIIIIIII",
          index,
          previousSecondElementOfTheArray,
          temp_arraction
        );
        setMapArray2(previousSecondElementOfTheArray);
      };


  // ............................Get API For Action .........................................//
  async function ActionGet() {
    // console.log("first");
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get-spam/action/attributes`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setActionData(result.data.actionAttributes);
        setActionData1(result.data.actionAttributes);

        let temp_arr = [];

        setHideSkeleton(false);
      } else {
        setActionData([]);
        // setOpen(false);
        setHideSkeleton(false);
        toast.error(result.data.statusDescription.statusdescription);
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton(false);
      toast.error("Please Check Your Network");
    }
  }

  // useEffect(() => {
  //   if(y!==""){
  //     ActionGet();
  //     console.log({ y });
  //     let temp_arr = [];
  //     if (y?.actionResponses) {
  //       // setMapArray(y?.actionResponses);
  //       let x = y?.actionResponses;
  //       console.log("x--", x);
  //       for (let i = 0; i < x?.length; i++) {
  //         temp_arr.push({
  //           attribute: { attribute: x[i].attribute },
  //           operations: { operations: x[i].operations },
  //           values: x[i].values,
  //         });
  //         setAtribute3Index(i);
  //         if (x[i]?.attribute == actionData[i]?.attribute) {
  //           console.log("enter");
  //           let x = [...conditionData3];
  
  //           x[i] = actionData[i]?.rulesOperations;
  //           setConditionData3(x);
  //         }
  //       }
  //       console.log("temp_arr", temp_arr);
  //       setMapArray2(temp_arr);
  //     }
  //   }
    
  
  //   // SpamOrGet();
  // }, [y]);

  useEffect(async () => {
    setMapArray2([])
     if (y !== "") {
      ActionGet();
    let temp_arr = [];
    let z = [...conditionData3];
    if (y?.actionResponses) {
      // setMapArray(y?.actionResponses);
      let x = y?.actionResponses;
      console.log("x--", x);
      if (x?.length > 0) {
        for (let i = 0; i < x?.length; i++) {
          temp_arr.push({
            attribute: { attribute: x[i].attribute },
            operations: { operations: x[i].operations },
            values: x[i].values,
            checkForNewVal:false

          });
          setAtribute3Index(i);
          // if (x[i]?.attribute == spam[i]?.attribute) {
          //   let z = [...conditionData1];

          //   z[i] = spam[i]?.rulesOperations;
          //   setConditionData1(z);
          //   console.log("enter", z);
          // }

          for (let j = 0; j < actionData?.length; j++) {
            if (x[i]?.attribute == actionData[j]?.attribute) {
              // alert("if");

              console.log("enter");

              z[i] = actionData?.[j]?.rulesOperations;
              console.log("z--", actionData[j]?.rulesOperations);

              break;
            }
          }
        }
        console.log("temp_arr", temp_arr, z);
        setConditionData3(z);
        setMapArray2(temp_arr);
      } else {
        // setMapArray1({
        //   attribute: null,
        //   operations: null,
        //   values: "",
        //   butt: "",
        //   messageSource: null,
        // });
      }
    }
     }

    // ActionGet();
    // SpamOrGet();
  }, [y]);


useEffect(()=>{
parentCallback(mapArray2,disableFields)
},[mapArray2])
useEffect(()=>{
  setDisableFields(disableFieldsRule)
},[disableFieldsRule])
  return (
<>
<main className="main-content position-relative border-radius-lg ">
        <div>
          {/* <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop> */}
        </div>
        <div className="card-body">
        <div className="card shadow-none border bg_blue mt-4"
        
        style={{
                                    //   height: "456px", 
                                      width:"900px",
                                      // overflow: "auto",
                                    }}>
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              {/* Add Number */}
              Action Condition
            </span>
            <div className="card-body px- text-lg-start text-center">
                                {/* ..............................AND Condition...................................... */}
                                <div className="mt-2">
                                <h3 class="spam_create">Action</h3>

                                  <div className="mt-3">
                                  {mapArray2?.map((data, index) => {
                                  return (
                                    <>
                                      <div className="row my-4" id="cross_row">
                                        <div
                                          className="col-md-3"
                                          id={
                                            mapArray2?.length - 1 != index
                                              ? "col_opacity1"
                                              : ""
                                          }
                                        >
                                          {hideSkeleton == true ? (
                                            <>
                                              <Box sx={{ width: "100%" }}>
                                                <Skeleton />
                                                <Skeleton animation="wave" />
                                                {/* <Skeleton animation={false} /> */}
                                              </Box>
                                            </>
                                          ) : (
                                            <>
                                              <Autocomplete
                                                disablePortal
                                                aria-required
                                                // disabled={
                                                //   mapArray2?.length - 1 == index && disableFields && !data?.checkForNewVal
                                                // }
                                                disabled={
                                      mapArray2?.length - 1 == index ?
                                      mapArray2?.length - 1 == index &&
                                       !data?.checkForNewVal:!data?.checkForNewVal
                                    }
                                                // disabled={
                                                //       formik.values.ruleName == ""
                                                //       ||
                                                //       accountcountryid ==""
                                                //       ||
                                                //       accountidvalue==null  ||
                                                //       response==""||
                                                //       formik.values.description
                                                //       ==""
                                                //            }
                                                className="w-100"
                                                id="combo-box-demo"
                                                size="small"
                                                options={actionData}
                                                getOptionLabel={(option) =>
                                                  option?.attribute
                                                }
                                                value={data?.attribute}
                                                onChange={(e, val) => {
                                                  console.log(e);

                                                  let temp_arr = [...mapArray2];
                                                  let temp_arraction1 = [
                                                    ...actionData,
                                                  ];
                                                  temp_arr[index].attribute =
                                                    val;
                                                  temp_arr[index].operations =
                                                    null;
                                                  setMapArray2(temp_arr);
                                                  console.log({ val });
                                                  temp_arraction1 =
                                                    temp_arraction1.filter(
                                                      (d) =>
                                                        d.attribute !=
                                                        val.attribute
                                                    );
                                                  // setActionData(
                                                  //   temp_arraction1
                                                  // );

                                                  setAtribute3Index(index);
                                                  setMapState2(true);
                                                }}
                                                sx={{ width: 150 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    required
                                                    {...params}
                                                    label="Select Action Name"
                                                  />
                                                )}
                                              />
                                            </>
                                          )}
                                        </div>
                                        <div
                                          className="col-md-3"
                                          id={
                                            data?.attribute == null ||
                                            mapArray2?.length - 1 != index
                                              ? "col_opacity1"
                                              : ""
                                          }
                                        >
                                          <>
                                            <Autocomplete
                                              disablePortal
                                              aria-required
                                              className="w-100"
                                              id="combo-box-demo"
                                              size="small"
                                              // disabled={
                                              //   mapArray2[index]?.attribute ==
                                              //     null ||
                                              //  ( mapArray2?.length - 1 == index && disableFields && !data?.checkForNewVal)
                                              // }
                                              disabled={
                                      mapArray2?.length - 1 == index ?
                                      mapArray2?.length - 1 == index &&
                                       !data?.checkForNewVal:!data?.checkForNewVal
                                    }
                                              // options={
                                              //   conditionData3?.length > 0
                                              //     ? conditionData3[index]
                                              //     : []
                                              // }
                                              options={
                                                conditionData3?.length > 0
                                    ? conditionData3?.[index]?.length > 0
                                      ? conditionData3?.[index]
                                      : []
                                    : []
                                              }
                                              getOptionLabel={(option) =>
                                                option?.operations || ""
                                              }
                                              value={data?.operations}
                                              onChange={(e, val) => {
                                                let temp_arraction = [
                                                  ...mapArray2,
                                                ];
                                                temp_arraction[
                                                  index
                                                ].operations = val;
                                                setMapArray2(temp_arraction);
                                                // setAtribute1Index(index);
                                              }}
                                              sx={{ width: 300 }}
                                              renderInput={(params) => (
                                                <TextField
                                                  required
                                                  {...params}
                                                  label="Select Condition"
                                                />
                                              )}
                                            />
                                          </>
                                        </div>

                                        {mapArray2[index]?.attribute
                                          ?.attribute == "Message Source" ? (
                                          <>
                                            <div
                                              className="col-md-3"
                                              id={
                                                mapArray2?.length - 1 != index
                                                  ? "col_opacity1"
                                                  : ""
                                              }
                                            >
                                              <FormControl
                                                sx={{ m: 0, minWidth: 180 }}
                                                size="small"
                                                // required
                                                // required={attribute1Index!=undefined}
                                              >
                                                <InputLabel id="demo-simple-select-autowidth-label">
                                                  Select Values
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-autowidth-label"
                                                  id="demo-simple-select-autowidth"
                                                  // disabled={
                                                  //   mapArray2?.length - 1 ==
                                                  //   index && disableFields && !data?.checkForNewVal
                                                  // }
                                                  disabled={
                                      mapArray2?.length - 1 == index ?
                                      mapArray2?.length - 1 == index &&
                                       !data?.checkForNewVal:!data?.checkForNewVal
                                    }
                                                  required={
                                                    mapArray2[index]?.attribute
                                                      ?.attribute ==
                                                    "Message Source"
                                                  }
                                                  // value={viewId}
                                                  // onChange={handleChange}
                                                  // onChange={(e) => setViewId(e.target.value)}

                                                  onChange={(e, val) => {
                                                    let temp_arraction = [
                                                      ...mapArray2,
                                                    ];
                                                    temp_arraction[
                                                      index
                                                    ].messageSource =
                                                      e.target.value;
                                                    setMapArray2(
                                                      temp_arraction
                                                    );
                                                    // setAtribute1Index(index);
                                                  }}
                                                  autowidth
                                                  label="Select Values"
                                                >
                                                  <MenuItem value="1">
                                                    HTTP
                                                  </MenuItem>
                                                  <MenuItem value="0">
                                                    SMPP
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div
                                              className="col-md-3"
                                              id={
                                                mapArray2?.length - 1 != index
                                                  ? "col_opacity1"
                                                  : ""
                                              }

                                              //  id={
                                              //                                           data?.values == ""
                                              //                                             ? "col_opacity1"
                                              //                                             : ""
                                              //                                         }
                                            >
                                              {/* <div className="d-flex justify-content-between align-items-center"> */}
                                              <TextField
                                              aria-required
                                                // disabled={
                                                //         mapArray2[index]?.operations == null
                                                //       }
                                                autoComplete="on"
                                                className="m-0 w-100"
                                                // disabled={
                                                //   mapArray2?.length - 1 == index && disableFields && !data?.checkForNewVal
                                                // }
                                                disabled={
                                      mapArray2?.length - 1 == index ?
                                      mapArray2?.length - 1 == index &&
                                       !data?.checkForNewVal:!data?.checkForNewVal
                                    }
                                                type="text"
                                              
                                                label="Value"
                                                name="values"
                                                variant="outlined"
                                                size="small"
                                                required
                                                value={data.values}
                                                onChange={(e) => {
                                                  let temp_arraction = [
                                                    ...mapArray2,
                                                  ];
                                                  temp_arraction[index].values =
                                                    e.target.value;
                                                  setMapArray2(temp_arraction);
                                                }}
                                                InputProps={{
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Tooltip
                                                        title="Value"
                                                        placement="top"
                                                        arrow
                                                        sx={{
                                                          color: "#85CBF2",
                                                        }}
                                                      >
                                                        <InfoIcon />
                                                      </Tooltip>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.values}
                                                // error={
                                                //   formik.touched.values &&
                                                //   Boolean(formik.errors.values)
                                                // }
                                                // helperText={
                                                //   formik.touched.values &&
                                                //   formik.errors.values
                                                // }
                                              />
                                            </div>
                                          </>
                                        )}

                                        {/* <div className="col-md-2 my-auto">
                                          <div className="">
                                            <Link
                                              className={
                                                data?.attribute == null
                                                  ? "d-block w-100"
                                                  : "d-block pop_up w-100"
                                              }
                                              onClick={() => {
                                                ModalAction(index);
                                                PopUpAction(index);
                                              }}
                                            >
                                              {data?.attribute?.attribute}
                                            </Link>
                                        
                                          </div>
                                        </div> */}

                                        {/* {index != 0 && (
                                          <> */}
                                            <div className="col-md-1 d-flex">
                                              <button
                                                type="button"
                                                className="btn w-auto bg-gradient-primary m-0 py-0 me-auto bgdanger1 "
                                                // disabled={
                                                //   mapArray2?.length - 1 != index
                                                // }
                                                onClick={() => {
                                                  firstaction(index);
                                                  let temp_arr = [...mapArray2];
                                                  let temp_arraction1 = [
                                                    ...actionData,
                                                  ];
                                                  temp_arraction1?.push(
                                                    temp_arr[index]
                                                      ?.attribute
                                                  );
                                                  temp_arr[index].attribute =
                                                    null;
                                                  temp_arr[index].operations =
                                                    null;

                                                  setActionData(
                                                    temp_arraction1
                                                  );
                                                }}
                                              >
                                                <DeleteIcon />
                                              </button>
                                            </div>
                                          {/* </>
                                        )} */}
                                      </div>
                                    </>
                                  );
                                })}
                                <button
                                  className="add-plus  mt-3"
                                  type="button"
                                  // id="col_opacity1"
                                  id={
                                    ( (mapArray2.length!=0 )?
                     mapArray2[mapArray2?.length - 1]?.attribute == null ||
                      mapArray2[mapArray2?.length - 1]?.operations == null ||
                      (mapArray2[mapArray2?.length - 1]?.values == "" &&
                        mapArray2[mapArray2?.length - 1]?.messageSource == null)
                        
                         :
                          false)
                                      ? "col_opacity1"
                                      : ""
                                  }
                                  // disabled={mapArray2?.length == 5}
                                  // disabled={
                                  //   mapArray2?.length == 5 ||
                                  //   attribute3Index === undefined ||
                                  //   mapArray2[attribute3Index]?.attribute ==
                                  //     null ||
                                  //   mapArray2[attribute3Index]?.operations ==
                                  //     null ||
                                  //   (mapArray2[attribute3Index]?.values == "" &&
                                  //     mapArray2[attribute3Index]
                                  //       ?.messageSource == null)
                                  // }
                                  disabled={
                      mapArray2?.length == 5 
                       ||
                      ( (mapArray2.length!=0 )
                      ? mapArray2[mapArray2?.length - 1]?.attribute == null ||
                          mapArray2[mapArray2?.length - 1]?.operations == null ||
                          (mapArray2[mapArray2?.length - 1]?.values == "" &&
                            mapArray2[mapArray2?.length - 1]?.messageSource ==
                              null)
                        
                         :
                          false)
                                  }
                    //       disabled={
                    //   mapArray1?.length == 5 ||
                    //   (mapArray1.length != 0
                    //     ? mapArray1[mapArray1?.length - 1]?.attribute == null ||
                    //       mapArray1[mapArray1?.length - 1]?.operations == null ||
                    //       (mapArray1[mapArray1?.length - 1]?.values == "" &&
                    //         mapArray1[mapArray1?.length - 1]?.messageSource ==
                    //           null)
                    //     : false)
                      
            
                                  onClick={addRule2}
                                >
                                  Add+
                                </button>
                                  </div>
                                </div>
            </div>
          </div>
         
        </div>
      </main>
</>

   
  )
}
